// extracted by mini-css-extract-plugin
export default {"container":"InteractiveArea_container__Sn7BQ"};